import axios from "axios";

export default function getReassignProgress(uuid) {
  return new Promise((resolve, reject) =>
    axios
      .get(`/distributor/system-admin/api/v1/reassign-progress/${uuid}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
